import { YARDI_SESSION_META_KEYS, YARDI_INVITE_LIST_FORM_KEYS } from '../constants'

/**
 * Picks filter fields from a saved list session. Without this, `perPage` / `page` / `sortBy` / `orderBy`
 * leak onto `filterForm` and `buildTrimmedParams(form)` overwrites freshly built request params (e.g. user
 * selects 30 rows but API still gets perPage 15 from the polluted form).
 */
export function extractYardiInviteListFormFromSession(
  session: Record<string, unknown>,
): Partial<Record<(typeof YARDI_INVITE_LIST_FORM_KEYS)[number], string>> {
  const stripped = stripMeta(session)
  const out: Partial<Record<(typeof YARDI_INVITE_LIST_FORM_KEYS)[number], string>> = {}
  for (const key of YARDI_INVITE_LIST_FORM_KEYS) {
    if (!(key in stripped)) continue
    const v = stripped[key]
    if (v === undefined || v === null) continue
    out[key] = typeof v === 'string' ? v : String(v)
  }
  return out
}

export function stripMeta<T extends Record<string, unknown>>(obj: T): T {
  const o = { ...obj } as T
  YARDI_SESSION_META_KEYS.forEach((k) => {
    delete (o as Record<string, unknown>)[k]
  })
  return o
}

export function readSessionJson<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function writeSessionJson(key: string, value: unknown) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* ignore */
  }
}

export function clearSessionKey(key: string) {
  try {
    sessionStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}
